import React from "react";
import PropTypes from "prop-types";
import { Tooltip } from "@mui/material";
import "./index.css";
import warningIcon from "./../../assets/design-revamp-company/warning-icons/notice-warning-icon.svg";

const TipBoxContent = ({ title, message }) => {
  return (
    <div
      className="warning-box"
      style={{
        padding: message ? "20px" : "5px",
      }}
    >
      <div className="warning-box-header">
        <img
          src={warningIcon}
          alt="Notice Warning Icon"
          width={18}
          height={18}
        />
        <span className="warning-box-title">{title}</span>
      </div>
      {message && (
        <div className="warning-box-content">
          <p>{message}</p>
        </div>
      )}
    </div>
  );
};

const TipBox = ({ title, message, children, customStyle, maxHeight = 400 }) => {
  return (
    <Tooltip
      style={customStyle}
      title={<TipBoxContent title={title} message={message} />}
      arrow
      placement="right"
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "transparent",
            maxHeight: maxHeight,
            marginTop: "20px",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "4px",
              border: "2px solid transparent",
              backgroundClip: "padding-box",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#666",
            },
            "& .MuiTooltip-arrow": {
              color: "white",
            },
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

TipBox.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

TipBoxContent.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
};

TipBox.defaultProps = {
  title: "Notice",
};

export default TipBox;
